/*
 * @Descripttion:
 * @version:
 * @Author: sujun
 * @email: 1373842098@qq.com
 * @Date: 2022-01-04 13:58:27
 * @LastEditors: linxi
 */
import { SettingOutlined } from '@ant-design/icons/lib/icons'
import deleteIcon from '../../../../compnents/icons/png/deleted.png'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Modal,
  ModalProps,
  Form,
  Row,
  Col,
  Radio,
  Switch,
  Select,
  Menu,
  Input,
  Dropdown,
  Cascader as Cascaded,
  notification,
  Space,
  Popconfirm,
} from 'antd'
import React, { ReactElement, useEffect, useState, useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import { ThemeContext } from '../../../../theme/ThemeContext'
import { replaceMakeInfoParams } from '../../../../services/recipe'
import { pageExamineAsync } from '../../../examinetreat/examinetreatSlice'
import styles from './RecipeItemModal.module.css'
import { useLocation } from 'react-router'
import {
  getBackfillDataAsync,
  getPatientAddressListAsync,
  removePatientAddressAsync,
  getPhoneList,
  getReplaceMakeSettingDetail,
  isSaveReplaceMakeSetting,
} from '../recipeEditorSlice'
import { stringTrim } from '../../../../utils/StringUtils'
import {
  carryTypeNumType,
  getCarryTypeName,
} from '../../../../models/ReplaceMakeSupplier'
import { getAddress } from '../../../registration/register/registerSlice'
import { DecoctingPersionalSettingModal } from './DecoctingPersionalSettingModal'
import { selectCredentials } from '../../../../app/applicationSlice'
import { AddOrEditDecoctingPersionalSettingModal } from './AddOrEditDecoctingPersionalSettingModal'
import {
  RecipeNormalDoseCategories,
  RecipeNormalDoseTypeName,
  RecipeNormalFrequencyCategories,
  RecipeNormalFrequencyName,
  RecipeNormalUsemethodCategories,
  RecipeNormalUsemethodName,
} from '../../../../models/decoctingSettingModal'

let potionMoneyAllList :any = []

// 后端用 -1 表示“不代煎”，前端单选项用 2 表示，回显时统一转换
const POTION_TYPE_NOT_DECOCT = 2

const normalizePotionType = (value?: any) => {
  if (value === undefined || value === null || value === '') {
    return ''
  }
  return Number(value) === -1 ? POTION_TYPE_NOT_DECOCT : Number(value)
}

interface ReplaceMakeSettingModalProps {
  settingDecoctionType?: any
  disabledFlag?: any
  patientPhone?: any
  patientName?: any
  RecipeStatus?: number
  onOk?: () => void
  onCancel?: () => void
  ReplaceMakeID?: number
  recipeId?: number
  visible?: boolean
  patientId?: number
  recipeCategory?: number
  isSetting?: boolean
  potionType?: number
  isOpenReplaceMake?: boolean
  isOpenPriceRatio?: boolean
}

export const DecoctingSettingModal = ({
  settingDecoctionType,
  disabledFlag,
  patientPhone,
  patientName,
  RecipeStatus,
  onOk,
  onCancel,
  patientId,
  recipeCategory,
  recipeId,
  visible,
  isSetting,
  potionType = 1,
  ReplaceMakeID,
  isOpenReplaceMake,
  isOpenPriceRatio,
  ...others
}: ReplaceMakeSettingModalProps & ModalProps): ReactElement => {

  // 处方状态为 3/5 时，代煎设置只读置灰：底部按钮不显示、控件置灰、偏好设置不展示
  const isLocked = RecipeStatus === 3 || RecipeStatus == 5
  const readonly = disabledFlag || isLocked

  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const [potionTypeValue, setPotionTypeValue] = useState<any>('')

  const [form] = Form.useForm()

  const [addressForm] = Form.useForm()

  const credentials = useSelector(selectCredentials)

  const location = useLocation()

  const [machiningTypeOptions, setMachiningTypeOptions] = useState<any>([]) // 代煎加工方式选项

  const [
    herbalMedicineFactoryList,
    setHerbalMedicineFactoryList,
  ] = useState<any>([]) //代煎饮片厂

  const [spuLIst, setSpuLIst] = useState<any>([])

  const [potionMoneyList, setPotionMoneyList] = useState<any>() //费用类别

  const [potionMoneyId, setPotionMoneyId] = useState<any>()

  const [isShowPotionMoney, setIsShowPotionMoney] = useState(true)

  const [addressTypes, setAddressTypes] = useState<any>([]) //收货位置

  const [phone, setPhone] = useState('') //电话

  const [id, setId] = useState<any>()

  const [phoneList, setPhoneList] = useState<any>([])

  const [needMoney, setNeedMoney] = useState(false)

  const [hasPotionMoney, setHasPotionMoney] = useState(false) // 代煎费用类别是否有值

  const [selectPotionType, setSelectPotionType] = useState<any>()

  const [selectSupplierId, setSelectSupplierId] = useState<any>()

  const [selectId, setSelectId] = useState<any>()

  const [disabled, setDisabled] = useState(true)

  const [isPhoneOverlayVisible, setIsPhoneOverlayVisible] = useState(false) // 控制手机号的下拉菜单

  const [
    isAddOrEditDecoctingPersionalSettingModalVisible,
    setIsAddOrEditDecoctingPersionalSettingModalVisible,
  ] = useState<any>() //代煎偏好设置

  const [
    isDecoctingPersionalSettingModalVisible,
    setIsDecoctingPersionalSettingModalVisible,
  ] = useState<any>() //代煎偏好设置

  const [areaId, setAreaId] = useState<any>([])

  const [allAreaList, setAllAreaList] = useState<any[]>()

  const [loading, setLoading] = useState<any>(false)

  const [addressModalVisible, setAddressModalVisible] = useState(false) // 地址选择弹窗

  const [patientAddressList, setPatientAddressList] = useState<any[]>([]) // 患者地址列表

  // 根据地区编码查找地区名称
  const getAreaName = (code: string): string => {
    if (!allAreaList || !code) return ''
    for (const province of allAreaList) {
      if (String(province.value) === String(code)) return province.label
      if (province.children) {
        for (const city of province.children) {
          if (String(city.value) === String(code)) return city.label
          if (city.children) {
            for (const region of city.children) {
              if (String(region.value) === String(code)) return region.label
            }
          }
        }
      }
    }
    return ''
  }

  const [
    potionPreferencesAddressVOList,
    setPotionPreferencesAddressVOList,
  ] = useState<any>()

  const rowProps = {
    gutter: 2,
  }

  const row = {
    gutter: 10,
    style: {
      color: theme.tc1,
      fontSize: '1rem',
    },
  }

  const col = {
    span: 3,
    style: {
      lineHeight: '2rem',
      textAlign: 'left',
      fontSize: '14px',
      marginBottom: '10px'
    } as React.CSSProperties,
  }

  const colProps = { span: 20 }

  const firstColumnLayout = {
    labelCol: { flex: '7rem' },
    wrapperCol: { flex: '20rem' },
  }
  const secondColumnLayout = {
    labelCol: { flex: '5rem' },
    wrapperCol: { flex: '15rem' },
  }
  const threeColumnLayout = {
    labelCol: { flex: '5rem' },
    wrapperCol: { flex: '39rem' },
  }

  const required = {
    rules: [
      {
        required: true,
      },
    ],
  }

  const loadData = (selectedOptions: any) => {
    const targetOption = selectedOptions[selectedOptions.length - 1]
    targetOption.loading = true
  }

  useEffect(() => {
    if (visible) {
      // 获取费用类别
      getExamineAsync()

      // 获取收货地区
      getAddressList()
      
      setDisabled(true)
      if (!isSetting) {
        setDefaultLocalPotionType()
      }
      const param = disabledFlag
        ? { decoctionType: settingDecoctionType ?? 0, patientId: patientId }
        : {
            decoctionType:
              location.pathname == '/retail' //(快速开单) && recipeCategory === 3 //(中药3)
                ? 2
                : recipeCategory == 3 //(中药3)
                ? 0
                : 1,
            patientId: patientId,
          }
      const data: replaceMakeInfoParams = {
        ...param,
        tenantRecipeId: recipeId!,
      }
      dispatch(getReplaceMakeSettingDetail({ ...data }))
        .then(unwrapResult)
        .then((res: any) => {
          setId(res?.id > 0 ? res?.id : null)
          // 判断有没有代煎饮片厂
          if (res?.supplierRespVOS?.length) {
            // 获取代煎饮片厂
            setHerbalMedicineFactoryList([...res?.supplierRespVOS])
            setSpuLIst([...res?.supplierRespVOS])
          } else {
            // 清空饮片厂以及加工方式的数据
            setHerbalMedicineFactoryList([])
            setMachiningTypeOptions([])
          }

          const dataParam = isSetting
            ? {
                ...param,
                tenantRecipeId: recipeId!,
              }
            : { patientId: patientId ,tenantRecipeIdDose: recipeId!}
          dispatch(getBackfillDataAsync({ ...dataParam }))
            .then(unwrapResult)
            .then((v: any) => {
              // 姓名只要接口返回了就回填
              fillConsigneeName(v)
              if (
                JSON.stringify(v) != '{}' &&
                hasValidPotionType(v?.potionType)
              ) {
                if (Number(v.supplierId) > 0) {
                  // 获取饮片厂id
                  const supplierIds =
                    v.supplierId || form.getFieldValue('supplierId')
                  MachiningTypeData(res?.supplierRespVOS, supplierIds)
                }
                // 回填偏好设置信息
                BackfillDataHuiTianMessage(v)
              } else {
                // 没有偏好设置且没有设置过代煎时，默认选中第一个代煎方式：本地
                defaultMessage(true)
                setPotionPreferencesAddressVOList([])
              }
              // 回填接口拿到的可能只是偏好设置（比如本地），代煎方式以设置详情接口保存过的值为准；
              // id > 0 表示这条处方有代煎设置记录，后端用 -1 表示“不代煎”
              if (Number(res?.id) > 0 && hasValidPotionType(res?.potionType)) {
                const detailPotionType = normalizePotionType(res?.potionType)
                form.setFieldsValue({ potionType: detailPotionType })
                setPotionTypeValue(
                  detailPotionType === '' ? '' : detailPotionType.toString()
                )
              }
            })
        })


    } else {
      setPotionTypeValue('')
    }
  }, [visible, recipeCategory, isSetting])

  useEffect(() => {
    if (!visible) {
      setId(null)
    } else {
      localStorage.setItem('notUseGlobalKeyboardAction', 'true')
    }
  }, [visible])

  // 加工方式获取方法
  const MachiningTypeData = (supplierRespVOS?: any, supplierId?: any) => {
    const TypeOptions = supplierRespVOS?.find(
      (item: any) => supplierId == item?.id
    )

    TypeOptions && setMachiningTypeOptions([...TypeOptions?.outPotionDictList])
  }

  // 加工方式没有值、为 -1 或不在当前可渲染的选项中，都视为未填写
  const isValidMachiningType = (value: any) => {
    if (value === undefined || value === null || value === '' || value == -1) {
      return false
    }
    // 本地代煎的可选项固定为 4（袋装液体）/ 5（颗粒剂）
    if (form.getFieldValue('potionType') == 0) {
      return value == 4 || value == 5
    }
    return machiningTypeOptions?.some(
      (item: any) => String(item?.typeVal) === String(value)
    )
  }

  // 加工方式的值不在当前可渲染的选项中（切换饮片厂、后端返回无效值等）时，统一清空视为未填写
  useEffect(() => {
    if (visible) {
      const currentPotionType = form.getFieldValue('potionType')
      if (currentPotionType == 0 || currentPotionType == 1) {
        const currentMachiningType = form.getFieldValue('machiningType')
        if (!isValidMachiningType(currentMachiningType)) {
          form.setFieldsValue({ machiningType: '' })
        }
      }
    }
  }, [visible, potionTypeValue, machiningTypeOptions])

  const getExamineAsync = () => {
    dispatch(
      // 获取费用类别
      pageExamineAsync({
        current: 1,
        size: 1000,
        state: 1,
        billingCategory: '97',
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        potionMoneyAllList = res.records
        setPotionMoneyList(res.records)
        setHasPotionMoney(res?.records?.length != 0)
        form.setFieldsValue({
          potionMoney: res?.records[0]?.id,
        })
      })
  }

  const getAddressList = () => {
    // 获取收货地区
    dispatch(getAddress())
      .then(unwrapResult)
      .then((res: any) => {
        setAllAreaList(res)
      })
  }

  const resetFormData = () => {
    form.resetFields()
    addressForm.resetFields()
    setPotionTypeValue('')
    setId(null)
    setPhone('')
    setAddressTypes('0')
    setLoading(false)
    setDisabled(false)
    localStorage.setItem('notUseGlobalKeyboardAction', 'false')
  }

  useEffect(() => {
    if (visible) {
      if (potionTypeValue == 0 || (potionTypeValue == 1 && isOpenReplaceMake)) {
        dispatch(getPhoneList(patientId ? patientId : 0))
          .then(unwrapResult)
          .then((res: any) => {
            if (res) {
              setPhoneList(res)
            } else {
              setPhoneList([])
            }
          })
      }
    }
  }, [visible, isOpenReplaceMake, potionTypeValue])

  // 切换饮片厂时从偏好获取信息回填（不区分设没设置过代煎）
  const getBackfillData = (v?: any) => {
    dispatch(
      getBackfillDataAsync({
        potionType: potionTypeValue || selectPotionType,
        supplierId: potionTypeValue == 1 || selectPotionType == 1 ? v : null,
        patientId: patientId,
      })
    )
      .then(unwrapResult)
      .then((v: any) => {
        if (JSON.stringify(v) != '{}') {
          BackfillDataHuiTianMessage(v, true)
          // 切换诊所自取/患者地址所需要的地址列表用作回显
          setPotionPreferencesAddressVOList(v?.potionPreferencesAddressVOList)
        } else {
          defaultMessage()
          setPotionPreferencesAddressVOList([])
        }
      })
  }

  const BackfillDataHuiTianMessage = (v: any, flag?: any) => {
    if (Number(v.supplierId) > 0) {
      MachiningTypeData(spuLIst, v?.supplierId)
    }
    const recipeNormalFrequency = localStorage.getItem(
      'recipeNormalFrequency'
    ) || ''
    const recipeNormalUsemethod = localStorage.getItem(
      'recipeNormalUsemethod'
    ) || ''
    const recipeNormalDose = localStorage.getItem('recipeNormalDose') || ''

    // 委外代煎永远只取后端接口的值
    const recipeNormalFrequencyValue =
      v?.potionType == 1 ? v?.recipeNormalFrequency : recipeNormalFrequency
    const recipeNormalUsemethodValue =
      v?.potionType == 1 ? v?.recipeNormalUsemethod: recipeNormalUsemethod
    const recipeNormalDoseValue =
      v?.potionType == 1 ? v?.recipeNormalDose : recipeNormalDose

    // 检查 treatmentServiceCatalogId 是否存在于 potionMoneyList 中
    const isValidPotionMoney = potionMoneyAllList?.some((item: any) => item.id === v?.treatmentServiceCatalogId)

    // 直接回填除配送地址之外的数据
    form.setFieldsValue({
      ...v,
      recipeNormalFrequency: recipeNormalFrequencyValue,
      recipeNormalUsemethod: recipeNormalUsemethodValue,
      recipeNormalDose: recipeNormalDoseValue,
      potionType: normalizePotionType(v?.potionType),
      packageNum: v?.packageNum > 0 ? v?.packageNum : '',
      potionMoney: isValidPotionMoney ? v?.treatmentServiceCatalogId : undefined,
      machiningType: v?.machiningType == -1 ? '' : v?.machiningType,
      supplierId: v?.supplierId == -1 ? '' : v?.supplierId,
    })
    const treatmentServiceCatalogId = hasValidTreatmentServiceCatalogId(v?.treatmentServiceCatalogId)
    // 判断是否需要代煎费
    setNeedMoney(treatmentServiceCatalogId ? true : false)
    setPotionMoneyId(
      treatmentServiceCatalogId ? v?.treatmentServiceCatalogId : ''
    )
    // 判断是否展示费用类别
    setIsShowPotionMoney(treatmentServiceCatalogId ? true : false)
    // 设置代煎方式标志位（后端 -1 表示不代煎，转成前端的 2）
    const potionType = normalizePotionType(v?.potionType)
    setPotionTypeValue(potionType === '' ? '' : potionType.toString())
    setAddressTypes(v?.addressType?.toString())
    addressForm.setFieldsValue({
      ...v,
      area:
        v?.province && v?.city && v?.region
          ? [Number(v?.province), Number(v?.city), Number(v?.region)]
          : [],
    })
    if (isSetting) {
      if (flag) {
        // 切换饮片厂的
        addressForm.setFieldsValue({
          carryType: v?.addressType == 1 ? 3 : 1,
        })
      } else {
        addressForm.setFieldsValue({
          carryType: hasValidCarryType(v?.carryType)
            ? Number(v?.carryType)
            : v?.addressType == 1
            ? 3
            : 1,
        })
      }
    } else {
      addressForm.setFieldsValue({
        carryType: v?.addressType == 1 ? 3 : 1,
      })
    }
    setPotionPreferencesAddressVOList(v?.potionPreferencesAddressVOList)
    setPhone(v?.phone)
    setDisabled(false)
  }

  // 姓名只要接口返回了就回填（本地/委外通用）
  const fillConsigneeName = (resp?: any) => {
    if (resp?.consigneeName) {
      addressForm.setFieldsValue({ consigneeName: resp.consigneeName })
    }
  }

  // 下拉菜单
  const patientOverlay = (
    <Menu>
      {phoneList.length &&
        phoneList?.map((p: any) => (
          <Menu.Item
            key={p}
            onClick={() => {
              setPhone(p)
            }}
          >
            {p}
          </Menu.Item>
        ))}
    </Menu>
  )

  const getDefaultLocalMachiningType = () => {
    return 4
  }

  const setDefaultLocalPotionType = () => {
    setPotionTypeValue('0')
    form.setFieldsValue({
      potionType: 0,
      machiningType: getDefaultLocalMachiningType(),
    })
  }

  const hasValidPotionType = (value: any) => {
    return (
      value !== undefined &&
      value !== null &&
      value !== '' &&
      // -1 为后端约定的“不代煎”，属于有效值
      [0, 1, 2, -1].includes(Number(value))
    )
  }

  const hasPreferenceBackfill = (value: any) => {
    return Number(value?.preferencesId || value?.preferenceId || value?.potionPreferencesId) > 0
  }

  const hasValidTreatmentServiceCatalogId = (value: any) => {
    return (
      value !== undefined &&
      value !== null &&
      value !== '' &&
      value !== -1 &&
      value !== '-1' &&
      value !== 0 &&
      value !== '0'
    )
  }

  const hasValidCarryType = (value: any) => {
    return (
      value !== undefined &&
      value !== null &&
      value !== '' &&
      value !== ' ' &&
      value !== -1 &&
      value !== '-1' &&
      carryTypeNumType.includes(Number(value))
    )
  }

  const isOutsourceReplaceMakeUnavailable = () => {
    return !isOpenReplaceMake || herbalMedicineFactoryList?.length == 0
  }

  const hasSelectedPotionType = (value: any) => {
    return value !== undefined && value !== null && value !== ''
  }

  const defaultMessage = (useDefaultLocalPotionType?: boolean) => {
    const provinceCode = credentials?.tenantProvinceCode
      ? Number(credentials?.tenantProvinceCode + '000000')
      : ''
    const cityCode = credentials?.tenantCityCode
      ? Number(credentials?.tenantCityCode + '000000')
      : ''
    const countryCode = credentials?.tenantCountyCode
      ? Number(credentials?.tenantCountyCode + '000000')
      : ''
    const tenantAddress = credentials?.tenantAddress
      ? credentials?.tenantAddress
      : ''
    // 代煎费默认不开启
    setNeedMoney(false)
    // 费用类别也不展示
    setIsShowPotionMoney(false)
    setPotionMoneyId('')
    setPhone(patientPhone)
    if (useDefaultLocalPotionType) {
      setDefaultLocalPotionType()
    }
    addressForm.setFieldsValue({
      potionMoney: '',
      addressType: 0,
      carryType: 1,
      area: provinceCode
        ? [Number(provinceCode), Number(cityCode), Number(countryCode)]
        : [],
      recipientAddress: '',
    })
    form.setFieldsValue({
      recipeNormalUsemethod: '每帖两次',
      recipeNormalDose: '每次200ml',
    })
    setAddressTypes('0')
    setDisabled(false)
  }

  // 未设置代煎,判断默认是本地,还是委外
  // (如果是本地,切换到委外,默认选中第0个代煎厂)
  // (如果是委外第一次就选中设置好的偏好,但如果切换到本地再次切回来,那么默认选中默认的代煎厂)
  const changeWWnotIsSetting = (value?: any) => {
    dispatch(getBackfillDataAsync({ patientId: patientId }))
      .then(unwrapResult)
      .then((res: any) => {
        // 姓名只要接口返回了就回填
        fillConsigneeName(res)
        if (JSON.stringify(res) != '{}') {
          // （res?.potionType == 0）如果之前设置的是本地代煎,（value == 1）切换到委外代煎时，默认选中第0个饮片厂回填
          if (res?.potionType == 0) {
            // 切换到委外代煎
            if (value == 1) {
              if (isOutsourceReplaceMakeUnavailable()) {
                // 未开通委外代煎
                defaultMessage()
              } else {
                // 获取第0个饮片厂的偏好设置信息
                getFirstSupplierData(value, spuLIst)
              }
            } else if (value == 0) {
              // 设置过的本地代煎的信息回填
              BackfillDataHuiTianMessage(res)
            }
          } else if (res?.potionType == 1) {
            // （res?.potionType == 1）如果之前是委外，(value == 0)切换到本地时，
            if (value == 0) {
              // 默认选中偏好设置的本地代煎内容
              getbendiPersonalSettingData(value)
            } else if (value == 1) {
              // 设置过的委外代煎的信息回填
              BackfillDataHuiTianMessage(res)
            } else {
              setDisabled(false)
            }
          } else {
            setDisabled(false)
          }
        } else {
          setDisabled(false)
        }
      })
  }

  // 获取第0个饮片厂的偏好设置信息
  const getFirstSupplierData = (value: any, supplierRespVOS: any) => {
    dispatch(
      getBackfillDataAsync({
        potionType: value,
        supplierId: value == 1 ? supplierRespVOS?.[0]?.id : null,
        patientId: patientId,
      })
    )
      .then(unwrapResult)
      .then((v: any) => {
        if (JSON.stringify(v) != '{}') {
          MachiningTypeData(supplierRespVOS, v.id)
          // 委外第0个饮片厂偏好设置的默认
          BackfillDataHuiTianMessage(v)
        } else {
          // 没设置偏好设置的话，给默认的省市区
          defaultMessage()
        }
      })
  }

  // 默认选中偏好设置的本地代煎内容
  const getbendiPersonalSettingData = (value?: any) => {
    dispatch(
      getBackfillDataAsync({
        potionType: value,
        patientId: patientId,
      })
    )
      .then(unwrapResult)
      .then((v: any) => {
        if (JSON.stringify(v) != '{}') {
          BackfillDataHuiTianMessage(v)
        } else {
          // 判断是否需要代煎费
          setNeedMoney(false)
          setDisabled(false)
          setPotionMoneyId('')
          // 判断是否展示费用类别
          setIsShowPotionMoney(false)
          // 判断代煎方式（后端 -1 表示不代煎，转成前端的 2）
          const potionType = normalizePotionType(v?.potionType)
          setPotionTypeValue(potionType === '' ? '' : potionType.toString())
        }
      })
  }

  // 设置过代煎,判断默认是本地,还是委外
  // (如果是本地,切换到委外,默认选中之前设置好的)
  // (如果是委外,第一次就选中设置好的偏好,但如果切换到本地再次切回来,那么默认选中之前设置好的)
  const changeWWIsSetting = (value?: any) => {
    const param = {
      decoctionType:
        location.pathname == '/retail' //(快速开单) && recipeCategory === 3 //(中药3)
          ? 2
          : recipeCategory == 3 //(中药3)
          ? 0
          : 1,
      patientId: patientId,
    }
    dispatch(
      getBackfillDataAsync({
        ...param,
        tenantRecipeId: recipeId!,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        // 姓名只要接口返回了就回填
        fillConsigneeName(res)
        if (JSON.stringify(res) != '{}') {
          // 设置代煎方式标志位
          // （res?.potionType == 0）如果之前设置的是本地代煎,（value == 1）切换到委外代煎时，默认选中第0个饮片厂回填
          if (res?.potionType == 0) {
            // 切换到委外代煎
            if (value == 1) {
              // 获取第0个饮片厂的偏好设置信息
              if (isOutsourceReplaceMakeUnavailable()) {
                // 未开通委外代煎
                defaultMessage()
              } else {
                getFirstSupplierData(value, spuLIst)
              }
            } else if (value == 0) {
              // 设置过的本地代煎的信息回填
              BackfillDataHuiTianMessage(res)
            }
          } else if (res?.potionType == 1) {
            // （res?.potionType == 1）如果之前是委外，(value == 0)切换到本地时，
            if (value == 0) {
              // 默认选中偏好设置的本地代煎内容
              getbendiPersonalSettingData(value)
            } else if (value == 1) {
              // 设置过的委外代煎的信息回填
              BackfillDataHuiTianMessage(res)
            } else {
              setDisabled(false)
            }
          } else {
            setDisabled(false)
          }
        } else {
          setDisabled(false)
        }
      })
  }

  return (
    <>
      <Modal
        {...others}
        visible={visible}
        title='代煎设置'
        width={850}
        maskClosable={false}
        destroyOnClose
        style={{ overflow: 'hidden', padding: '0' }}
        className={styles.decoctingSettingModal}
        onCancel={(e) => {
          onCancel && onCancel(e)
          resetFormData()
        }}
        okButtonProps={{
          disabled: (potionTypeValue == 1 && isOutsourceReplaceMakeUnavailable()) || disabled,
        }}
        confirmLoading={loading}
        onOk={async (e) => {
          // 加工方式不在当前可选项中时视为未填写，交由必填规则拦住
          if (!isValidMachiningType(form.getFieldValue('machiningType'))) {
            form.setFieldsValue({ machiningType: '' })
          }
          try {
            await form.validateFields()
          } catch {
            setLoading(false)
            return
          }
          setLoading(true)
          const potionTypeValues = form.getFieldValue('potionType')
          const machiningTypes = form.getFieldValue('machiningType')
          // const flag = machiningTypes == 2 || machiningTypes == 3
          if (potionTypeValues == 0) {
            // 本地代煎保存
            form.validateFields().then((v: any) => {
              addressForm.validateFields().then((el: any) => {
                const potionMoney = potionMoneyList?.find((item: any) => {
                  return item?.id == v?.potionMoney
                })?.retailPrice
                const costPrice = potionMoneyList?.find((item: any) => {
                  return item?.id == v?.potionMoney
                })?.costPrice
                const data = {
                  area: null,
                  patientId: patientId || '',
                  province: el?.area?.[0] && el?.area?.[0],
                  city: el?.area?.[1] && el?.area?.[1],
                  region: el?.area?.[2] && el?.area?.[2],
                  tenantRecipeId: recipeId, //处方id
                  decoctionType: disabledFlag
                    ? settingDecoctionType ?? 0
                    : recipeCategory == 3
                      ? 0
                      : 1,
                  treatmentServiceId: needMoney ? potionMoneyId : '0',
                  potionMoney: needMoney ? potionMoney : 0,
                  costPrice: costPrice == -1 ? 0 : costPrice,
                  consigneePhone: phone,
                  id: id || null,
                  type: needMoney ? 1 : 0, // 0需要代煎费
                  carryType: el?.carryType ? Number(el?.carryType) : 1,
                  potionFeeFixed: disabledFlag ? true : false,
                }

                if (data?.province && data?.city && data?.region) {
                  dispatch(isSaveReplaceMakeSetting({ ...v, ...el, ...data }))
                    .then(unwrapResult)
                    .then(() => {
                      resetFormData()
                      onOk && onOk(e)
                      localStorage.setItem(
                        'recipeNormalFrequency',
                        v?.recipeNormalFrequency || ''
                      )
                      localStorage.setItem(
                        'recipeNormalUsemethod',
                        v?.recipeNormalUsemethod || ''
                      )
                      localStorage.setItem(
                        'recipeNormalDose',
                        v?.recipeNormalDose || ''
                      )
                    })
                    .finally(() => {
                      setLoading(false)
                    })
                } else {
                  notification.error({
                    message: '请选择完整的收货地址（补全省市区）',
                  })
                  setLoading(false)
                }
              })
            })
          } else if (potionTypeValues == 1) {
            // 委外代煎保存
            form.validateFields().then((values: any) => {
              addressForm.validateFields().then((el: any) => {
                const potionMoney = potionMoneyList?.find((item: any) => {
                  return item?.id == values?.potionMoney
                })?.retailPrice
                const costPrice = potionMoneyList?.find((item: any) => {
                  return item?.id == values?.potionMoney
                })?.costPrice
                const data = {
                  area: null,
                  patientId: patientId || '',
                  province: el?.area[0] && el?.area[0],
                  city: el?.area[1] && el.area[1],
                  region: el?.area[2] && el.area[2],
                  tenantRecipeId: recipeId,
                  decoctionType: disabledFlag
                    ? settingDecoctionType ?? 0
                    : recipeCategory == 3
                      ? 0
                      : 1,
                  treatmentServiceId: needMoney ? potionMoneyId : '0',
                  potionMoney: needMoney ? potionMoney : 0,
                  costPrice: costPrice == -1 ? 0 : costPrice,
                  consigneePhone: phone,
                  id: id || null,
                  type: needMoney ? 1 : 0, // 0需要代煎费
                  carryType: el?.carryType ? Number(el?.carryType) : 1,
                  potionFeeFixed: disabledFlag ? true : false,
                }

                if (data?.province && data?.city && data?.region) {
                  dispatch(
                    isSaveReplaceMakeSetting({ ...values, ...el, ...data })
                  )
                    .then(unwrapResult)
                    .then(() => {
                      localStorage.setItem(
                        'recipeNormalFrequency',
                        values?.recipeNormalFrequency || ''
                      )
                      localStorage.setItem(
                        'recipeNormalUsemethod',
                        values?.recipeNormalUsemethod || ''
                      )
                      localStorage.setItem(
                        'recipeNormalDose',
                        values?.recipeNormalDose || ''
                      )
                      onOk && onOk(e)
                      resetFormData()
                    })
                    .finally(() => {
                      setLoading(false)
                    })
                } else {
                  notification.error({
                    message: '请选择完整的收货地址（补全省市区）',
                  })
                  setLoading(false)
                }
              })
            })
          } else if (potionTypeValues == 2) {
            dispatch(
              isSaveReplaceMakeSetting({
                potionType: 2,
                id: id || null,
                tenantRecipeId: Number(recipeId),
                potionFeeFixed: disabledFlag ? true : false,
              })
            )
              .then(unwrapResult)
              .then(() => {
                resetFormData()
                onOk && onOk(e)
              })
              .finally(() => {
                setLoading(false)
              })
          }
        }}
        footer={isLocked ? null : undefined}

      >
        <Form
          form={form}
          colon={false}
          autoComplete='off'
          labelAlign='left'
          initialValues={{
            machiningType:
              location.pathname !== '/retail' && recipeCategory == 3 ? 4 : 5,
          }}
        >
          <section
            className={potionTypeValue != 2 ? styles.container : ''}
            style={{
              padding: '0 20px',
              marginBottom: 20,
              position: 'relative',
            }}
          >
            {readonly ? (
              <></>
            ) : (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  color: '#027AFF',
                  position: 'absolute',
                  right: 0,
                }}
              >
                <SettingOutlined
                  style={{
                    fontSize: '20px',
                    color: '#027AFF',
                  }}
                />
                <a
                  type='text'
                  style={{
                    marginLeft: '6px',
                    fontSize: '16px',
                    color: '#027AFF',
                  }}
                  onClick={() => {
                    setIsAddOrEditDecoctingPersionalSettingModalVisible(true)
                    localStorage.setItem('notUseGlobalKeyboardAction', 'true')
                    onCancel && onCancel()
                  }}
                >
                  偏好设置
                </a>
              </div>
            )}

            <Row className={styles.title}>代煎方式</Row>
            <Row {...rowProps}>
              <Col {...colProps} className={styles.disabledMain}>
                <Form.Item
                  {...firstColumnLayout}
                  label='代煎方式'
                  name='potionType'
                  rules={[{ required: true, message: '请选择代煎方式!' }]}
                >
                  <Radio.Group
                    disabled={readonly ? true : false}
                    onChange={(e) => {
                      const { value } = e.target
                      if (value != 2) {
                        setDisabled(true)
                      } else {
                        // 不代煎没有详情需要回填，保存按钮直接可用
                        setDisabled(false)
                      }
                      if (value == 1 && isOutsourceReplaceMakeUnavailable()) {
                        notification.info({
                          message:
                            '您尚未开通委外代煎服务，您可以联系客服开通，或选择本地代煎。',
                        })
                      }
                      setPotionTypeValue(value?.toString())
                      if (!isSetting) {
                        changeWWnotIsSetting(value)
                      } else {
                        changeWWIsSetting(value)
                      }
                    }}
                  >
                    <Radio value={0}>本地</Radio>
                    <Radio value={1}>委外</Radio>
                    <Radio value={2}>不代煎</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
            {
              // 本地
              hasSelectedPotionType(potionTypeValue) && potionTypeValue?.toString() == '0' ? (
                // 本地
                <Row {...rowProps}>
                  <Col {...colProps} className={styles.disabledMain}>
                    <Form.Item
                      {...firstColumnLayout}
                      label='加工方式'
                      name='machiningType'
                      rules={[{ required: true, message: '请选择加工方式!' }]}
                    >
                      <Radio.Group disabled={readonly ? true : false}>
                        <Radio value={4}>本地代煎袋装液体</Radio>
                        <Radio value={5}>本地代煎颗粒剂</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                </Row>
              ) : potionTypeValue == 1 ? (
                // 委外
                <Row {...rowProps}>
                  <Col {...colProps} className={styles.disabledMain}>
                    <Form.Item
                      labelCol={{ flex: '7rem' }}
                      wrapperCol={{ flex: 1 }}
                      label='代煎饮片厂'
                      name='supplierId'
                      rules={[{ required: true, message: '请选择代煎饮片厂!' }]}
                      style={{
                        position: 'relative',
                      }}
                    >
                      {potionTypeValue == 1 && isOutsourceReplaceMakeUnavailable() ? (
                        <>
                          您尚未开通委外代煎服务，请联系客服申请开通，了解
                          <a
                            href='javascript:;'
                            style={{
                              color: '#0076FF',
                              textDecoration: 'underline',
                            }}
                            onClick={() => {
                              window.open(
                                window.location.origin + '/productCenter',
                                '_blank'
                              )
                            }}
                          >
                            更多详情
                          </a>{' '}
                          <br />
                          客服联系方式：
                          <span
                            style={{
                              color: '#0076FF',
                            }}
                          >
                            17300983625
                          </span>
                        </>
                      ) : (
                        <>
                          <Form.Item
                            name='supplierId'
                            rules={[{ required: true, message: ' ' }]}
                            style={{
                              position: 'relative',
                            }}
                          >
                            <Radio.Group
                              disabled={readonly ? true : false}
                              onChange={(e) => {
                                const { value } = e.target
                                MachiningTypeData(spuLIst, value)
                                getBackfillData(value)
                              }}
                            >
                              <Space direction='vertical'>
                                {herbalMedicineFactoryList?.map((v: any) => (
                                  <Radio value={v.id} key={v.id}>
                                    <Row align='middle'>{v.supplierName}</Row>
                                    {v.signedType == 0 && (
                                      <div
                                        style={{
                                          backgroundColor: '#DDEDFF',
                                          padding: '5px 10px',
                                        }}
                                      >
                                        {v.signedMsg}
                                      </div>
                                    )}
                                  </Radio>
                                ))}
                              </Space>
                            </Radio.Group>
                          </Form.Item>
                        </>
                      )}
                    </Form.Item>
                  </Col>
                  <Col {...colProps} className={styles.disabledMain}>
                    <Form.Item
                      {...firstColumnLayout}
                      label='加工方式'
                      name='machiningType'
                      rules={[{ required: true, message: '请选择加工方式!' }]}
                    >
                      <Radio.Group
                        disabled={readonly ? true : false}
                        onChange={(e) => {
                          return
                        }}
                      >
                        {machiningTypeOptions?.map((v: any) => (
                          <Radio value={v.typeVal} key={v.id}>
                            {v.name}
                          </Radio>
                        ))}
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                </Row>
              ) : (
                <></>
              )
            }
          </section>
          {hasSelectedPotionType(potionTypeValue) && potionTypeValue != 2 ? (
            <section
              className={potionTypeValue != 0 ? styles.contater : ''}
              style={{ padding: '0 20px', marginBottom: 20 }}
            >
              <Row className={styles.title}>代煎详情 </Row>
              <Row>
                <Col span={12}>
                  <Form.Item label='代煎费' name='type' {...secondColumnLayout}>
                    <Switch
                      disabled={readonly ? true : false}
                      checkedChildren='添加'
                      unCheckedChildren='关闭'
                      checked={needMoney}
                      onChange={(v) => {
                        setNeedMoney(v)
                        setPotionMoneyId(potionMoneyList?.[0]?.id)
                        form.setFieldsValue({
                          potionMoney: potionMoneyList?.[0]?.id,
                        })
                        if (v && !hasPotionMoney) {
                          setHasPotionMoney(false)
                          setNeedMoney(false)
                          setPotionMoneyId('')
                          notification.info({
                            message: '请先在诊疗管理设置代煎费选项',
                          })
                        } else {
                          setIsShowPotionMoney(v)
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
                {isShowPotionMoney && (
                  <Col span={12} className={styles.disabledMain}>
                    <Form.Item
                      label='费用类别'
                      name='potionMoney'
                      {...required}
                      {...secondColumnLayout} 
                      style={{marginLeft:form.getFieldValue('potionType') == 0 ? '-10px' : '0'}}
                    >
                      <Select
                        disabled={readonly ? true : false}
                        placeholder='请选择费用类别'
                        onSelect={(v: any, s: any) => {
                          setPotionMoneyId(v)
                        }}
                      >
                        {potionMoneyList?.map((el: any) => (
                          <Select.Option key={el.id} value={el.id}>
                            {el.name}: {el.retailPrice} 元
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                )}
                {(potionTypeValue?.toString() == '0' || potionTypeValue?.toString() == '1') && (
                  <Row
                    wrap={false}
                    align='middle'
                    {...row}
                  >
                    <Col {...col}>处方剂型</Col>
                    <Form.Item name='recipeNormalFrequency' >
                      <Select
                        placeholder='请选择'
                        allowClear
                        disabled={isLocked}
                        style={{ width: '200px', marginRight: '10px' }}
                      >
                        {RecipeNormalFrequencyCategories?.map((v) => {
                          return (
                            <Select.Option value={v} key={v}>
                              {RecipeNormalFrequencyName(v)}
                            </Select.Option>
                          )
                        })}
                      </Select>
                    </Form.Item>
                    <Form.Item name='recipeNormalUsemethod' >
                      <Select
                        placeholder='请选择'
                        allowClear
                        disabled={isLocked}
                        style={{ width: '202px', marginRight: '10px' }}
                      >
                       {RecipeNormalUsemethodCategories?.map((v) => {
                          return (
                            <Select.Option value={v} key={v}>
                              {RecipeNormalUsemethodName(v)}
                            </Select.Option>
                          )
                        })}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      name='recipeNormalDose'
                      style={{ flex: 1 }}
                    >
                      <Select
                        placeholder='请选择'
                        allowClear
                        disabled={isLocked}
                        style={{ width: '200px' }}
                      >
                        {RecipeNormalDoseCategories?.map((v) => {
                          return (
                            <Select.Option value={v} key={v}>
                              {RecipeNormalDoseTypeName(v)}
                            </Select.Option>
                          )
                        })}
                      </Select>
                    </Form.Item>
                  </Row>
                )}
              </Row>

              {potionTypeValue == 1 ? (
                <Row>
                  {/*<Col span={12}>*/}
                  {/*  <Form.Item*/}
                  {/*    label='包装规格'*/}
                  {/*    name='specification'*/}
                  {/*    {...secondColumnLayout}*/}
                  {/*  >*/}
                  {/*    <Input maxLength={15} />*/}
                  {/*  </Form.Item>*/}
                  {/*</Col>*/}
                  {spuLIst
                    .find((v: any) => v.id == form.getFieldValue('supplierId'))
                    ?.supplierName?.indexOf('再生方') >= 0 ? (
                    <Col span={12}>
                      <Form.Item
                        label='包数'
                        name='packageNum'
                        {...secondColumnLayout}
                      >
                        <Input maxLength={30} type='number' disabled={isLocked} />
                      </Form.Item>
                    </Col>
                  ) : (
                    ''
                  )}
                </Row>
              ) : (
                ''
              )}

              {/* 备注：本地/委外均支持（仿照委外） */}
              {(potionTypeValue?.toString() == '0' ||
                potionTypeValue?.toString() == '1') && (
                <Row>
                  <Col span={24}>
                    <Form.Item
                      label='备注'
                      name='remark'
                      {...threeColumnLayout}
                    >
                      <Input maxLength={30} disabled={isLocked} />
                    </Form.Item>
                  </Col>
                </Row>
              )}
            </section>
          ) : (
            <></>
          )}
        </Form>
        {hasSelectedPotionType(potionTypeValue) && potionTypeValue != 2 && (
          <Form form={addressForm} colon={false} autoComplete='off'>
            <section style={{ padding: '0 20px', marginBottom: 20 }}>
              <Row className={styles.title}>配送信息</Row>
              <Row>
                {potionTypeValue?.toString() == '0' ||
                (spuLIst
                  .find((v: any) => v.id == form.getFieldValue('supplierId'))
                  ?.supplierName?.indexOf('再生方') ?? -1) < 0 ? (
                  <Col span={12}>
                    <Form.Item
                      initialValue={1}
                      label='配送方式'
                      name='carryType'
                      {...secondColumnLayout}
                    >
                      <Select placeholder='请选择配送方式' disabled={isLocked}>
                        {carryTypeNumType?.map((v: any) => (
                          <Select.Option key={v} value={v}>
                            {getCarryTypeName(v)}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                ) : (
                  <Col span={12}></Col>
                )}
                <Col span={12}>
                  <div style={{ position: 'relative', display: 'inline-block' }}>
                    <Form.Item label='收货位置' {...secondColumnLayout} style={{ marginBottom: 0 }}>
                      <Form.Item name='addressType' noStyle>
                        <Select
                          placeholder='请选择收货位置'
                          style={{ width: '100%' }}
                          disabled={isLocked}
                          onChange={(v: any) => {
                            addressForm.setFieldsValue({
                              recipientAddress: '',
                              area: [],
                            })
                            setPhone('')
                            setAddressTypes(v?.toString())
                            const addressData = potionPreferencesAddressVOList?.find(
                              (res: any) => res?.addressType == v
                            )
                            addressForm.setFieldsValue({
                              ...addressData,
                              area:
                                addressData?.province &&
                                addressData?.city &&
                                addressData?.region
                                  ? [
                                      Number(addressData?.province),
                                      Number(addressData?.city),
                                      Number(addressData?.region),
                                    ]
                                  : [],
                            })
                            setPhone(phone)
                            if (v == 0) {
                              addressForm.setFieldsValue({
                                carryType: 1,
                              })
                            } else {
                              addressForm.setFieldsValue({
                                carryType: 3,
                              })
                            }
                          }}
                        >
                          <Select.Option key={0} value={0}>
                            患者地址
                          </Select.Option>
                          <Select.Option key={1} value={1}>
                            诊所自取
                          </Select.Option>
                        </Select>
                      </Form.Item>
                    </Form.Item>
                    {!isLocked && addressTypes == '0' && (
                      <a
                        style={{
                          position: 'absolute',
                          left: '100%',
                          top: 0,
                          color: '#266FFF',
                          fontSize: '14px',
                          whiteSpace: 'nowrap',
                          cursor: 'pointer',
                          lineHeight: '32px',
                          marginLeft: 8,
                        }}
                        onClick={() => {
                          if (patientId) {
                            dispatch(getPatientAddressListAsync(patientId))
                              .then(unwrapResult)
                              .then((res: any) => {
                                setPatientAddressList(res || [])
                                setAddressModalVisible(true)
                                localStorage.setItem('notUseGlobalKeyboardAction', 'true')
                              })
                          }
                        }}
                      >
                        地址选择
                      </a>
                    )}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col span={12}>
                  <Form.Item
                    label='姓名'
                    name='consigneeName'
                    {...secondColumnLayout}
                    getValueFromEvent={stringTrim}
                  >
                    <Input maxLength={12} disabled={isLocked} />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label='联系电话'
                    name='Phone'
                    {...secondColumnLayout}
                  >
                    <Dropdown
                      overlay={patientOverlay}
                      visible={isPhoneOverlayVisible}
                      disabled={isLocked}
                    >
                      <Input
                        allowClear
                        disabled={isLocked}
                        placeholder={'请输入联系电话'}
                        value={phone}
                        name='consigneePhone'
                        onFocus={() => {
                          phoneList.length && setIsPhoneOverlayVisible(true)
                        }}
                        onBlur={() => {
                          setTimeout(() => {
                            setIsPhoneOverlayVisible(false)
                          }, 200)
                        }}
                        onClick={() => {
                          phoneList.length && setIsPhoneOverlayVisible(true)
                        }}
                        onChange={(e) => {
                          setPhone(e.target.value)
                        }}
                      />
                    </Dropdown>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24} style={{ display: 'flex' }}>
                  <Col span={24} className={styles.disabledMain}>
                    <Form.Item
                      label='收货地区'
                      name='area'
                      {...threeColumnLayout}
                    >
                      <Cascaded
                        disabled={isLocked || addressTypes == 1}
                        loadData={loadData}
                        changeOnSelect
                        style={{ width: '240px' }}
                        options={allAreaList}
                        onChange={() => setAreaId([])}
                        placeholder='请选择省市区'
                      />
                    </Form.Item>
                  </Col>
                </Col>
              </Row>
              <Row>
                <Col span={24} className={styles.disabledMain}>
                  <Form.Item
                    label='收货地址'
                    name='recipientAddress'
                    getValueFromEvent={stringTrim}
                    {...threeColumnLayout}
                  >
                    <Input
                      maxLength={100}
                      disabled={isLocked || addressTypes == '1'}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </section>
          </Form>
        )}
      </Modal>
      <Modal
        title={null}
        visible={addressModalVisible}
        width={600}
        footer={null}
        closable={false}
        destroyOnClose
        maskStyle={{ backgroundColor: 'rgba(0,0,0,0)' }}
        bodyStyle={{
          padding: '20px',
          height: 300,
          overflow: 'auto',
        }}
        style={{ top: '25%', borderRadius: '10px' }}
        onCancel={() => {
          setAddressModalVisible(false)
          localStorage.setItem('notUseGlobalKeyboardAction', 'false')
        }}
      >
        {patientAddressList.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#999', padding: '40px 0' }}>
            暂无地址记录
          </div>
        ) : (
          patientAddressList.map((addr: any, index: number) => {
            // 判断地址是否与当前配送信息一致
            const currentName = addressForm.getFieldValue('consigneeName') || ''
            const currentAddress = addressForm.getFieldValue('recipientAddress') || ''
            const currentArea: any[] = addressForm.getFieldValue('area') || []
            const isSelected =
              addr.consigneeName === currentName &&
              addr.consigneePhone === phone &&
              addr.recipientAddress === currentAddress &&
              String(addr.province || '') === String(currentArea[0] || '') &&
              String(addr.city || '') === String(currentArea[1] || '') &&
              String(addr.region || '') === String(currentArea[2] || '')

            return (
            <div
              key={index}
              style={{
                width: '100%',
                minHeight: 72,
                lineHeight: '20px',
                borderRadius: 6,
                backgroundColor: isSelected ? 'rgba(242,246,255,1)' : 'rgba(243,243,243,1)',
                color: 'rgba(16,16,16,1)',
                fontSize: 14,
                textAlign: 'left',
                fontFamily: 'PingFangSC-bold',
                padding: '12px 16px',
                marginBottom: 12,
                cursor: 'pointer',
                border: isSelected ? '1px solid rgba(38,111,255,1)' : '1px solid transparent',
                position: 'relative',
              }}
              onMouseEnter={(e) => {
                if (!isSelected) {
                  e.currentTarget.style.backgroundColor = 'rgba(242,246,255,1)'
                  e.currentTarget.style.border = '1px solid rgba(38,111,255,1)'
                }
              }}
              onMouseLeave={(e) => {
                if (!isSelected) {
                  e.currentTarget.style.backgroundColor = 'rgba(243,243,243,1)'
                  e.currentTarget.style.border = '1px solid transparent'
                }
              }}
              onClick={() => {
                // 回填姓名
                addressForm.setFieldsValue({
                  consigneeName: addr.consigneeName || '',
                })
                // 回填电话
                setPhone(addr.consigneePhone || '')
                addressForm.setFieldsValue({
                  Phone: addr.consigneePhone || '',
                })
                // 回填省市区
                if (addr.province && addr.city && addr.region) {
                  addressForm.setFieldsValue({
                    area: [
                      Number(addr.province),
                      Number(addr.city),
                      Number(addr.region),
                    ],
                  })
                }
                // 回填收货地址
                addressForm.setFieldsValue({
                  recipientAddress: addr.recipientAddress || '',
                })
                setAddressModalVisible(false)
                localStorage.setItem('notUseGlobalKeyboardAction', 'false')
              }}
            >
              {addr.canDelete && (
                <Popconfirm
                  placement='top'
                  title='确认删除该地址？'
                  onConfirm={() => {
                    if (addr.id && patientId) {
                      dispatch(removePatientAddressAsync(String(addr.id)))
                        .then(unwrapResult)
                        .then(() => {
                          dispatch(getPatientAddressListAsync(patientId))
                            .then(unwrapResult)
                            .then((res: any) => {
                              setPatientAddressList(res || [])
                            })
                        })
                    }
                  }}
                  okText='确认'
                  cancelText='取消'
                >
                  <img
                    src={deleteIcon}
                    alt='删除'
                    style={{
                      position: 'absolute',
                      top: 12,
                      right: 16,
                      width: 16,
                      height: 16,
                      cursor: 'pointer',
                    }}
                    onClick={(e) => e.stopPropagation()}
                  />
                </Popconfirm>
              )}
              <div style={{ fontWeight: 'bold', paddingRight: addr.canDelete ? 24 : 0 }}>
                {addr.consigneeName} {addr.consigneePhone}
              </div>
              <div>
                {[
                  getAreaName(addr.province),
                  getAreaName(addr.city),
                  getAreaName(addr.region),
                  addr.recipientAddress || '',
                ]
                  .filter(Boolean)
                  .join(' ')}
              </div>
            </div>
            )
          })
        )}
      </Modal>
      <DecoctingPersionalSettingModal
        selectSupplierId={selectSupplierId}
        selectId={selectId}
        selectPotionType={selectPotionType}
        recipeId={recipeId}
        patientId={patientId}
        recipeCategory={recipeCategory}
        isSetting={isSetting}
        isOpenReplaceMake={isOpenReplaceMake}
        visible={isDecoctingPersionalSettingModalVisible}
        onOk={() => {
          setIsDecoctingPersionalSettingModalVisible(false)
        }}
        onCancel={() => {
          setIsDecoctingPersionalSettingModalVisible(false)
        }}
      ></DecoctingPersionalSettingModal>
      <AddOrEditDecoctingPersionalSettingModal
        recipeId={recipeId}
        patientId={patientId}
        recipeCategory={recipeCategory}
        isSetting={isSetting}
        isOpenReplaceMake={isOpenReplaceMake}
        visible={isAddOrEditDecoctingPersionalSettingModalVisible}
        onOk={() => {
          setIsAddOrEditDecoctingPersionalSettingModalVisible(false)
        }}
        onCancel={() => {
          setIsAddOrEditDecoctingPersionalSettingModalVisible(false)
        }}
        addPersionalMessage={(potionType, supplierId, id) => {
          setSelectPotionType(potionType)
          setSelectSupplierId(supplierId)
          setSelectId(id)
          setIsDecoctingPersionalSettingModalVisible(true)
          setIsAddOrEditDecoctingPersionalSettingModalVisible(false)
        }}
      ></AddOrEditDecoctingPersionalSettingModal>
    </>
  )
}
